import React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/utils/utils';

const labelVariants = cva(
    'text-fs-mid14 leading-lh-nor14 font-custom-bold peer-disabled:cursor-not-allowed peer-disabled:opacity-70 inline-block'
);

const Label = React.forwardRef<
    React.ElementRef<typeof LabelPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants> &
    { required?: boolean }
>(({ className, required, ...props }, ref) => (
    <LabelPrimitive.Root
        ref={ref}
        className={cn(labelVariants(), required && 'after:content-["_*"] after:text-red-700', className)}
        {...props}
    />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
